import React, { Fragment, Component, useState } from 'react';
import * as Sentry from '@sentry/browser';

import { sentryCaptureException } from '../../util/sentry';
import Alert from '../../components/global/Alert';
import Button from '../../components/global/Button';

const Error = () => {
  window.generateError();
};

const ErrorButton = () => {
  const [error, setError] = useState(false);

  const onGenerateError = () => {
    setError(false);
    setError(true);
  };

  return (
    <Fragment>
      <Button
        className="mt-3"
        btnBlock
        btnStyle="danger"
        onClick={onGenerateError}
      >
        Caught Error
      </Button>
      {error && <Error />}
    </Fragment>
  );
};

class ErrorTesting extends Component {
  state = {
    error: '',
    eventId: null,
    errorInfo: null,
  };

  componentDidCatch(error, errorInfo) {
    const eventId = sentryCaptureException(error, errorInfo);

    this.setState(() => ({ error: true, errorInfo, eventId }));
  }

  render() {
    const { error, errorInfo, eventId } = this.state;

    return (
      <div className="max-w-33p m-auto">
        {error && <Alert type="danger">{JSON.stringify(errorInfo)}</Alert>}

        <div className="d-flex flex-column mt-3">
          <Button
            className="mt-3"
            btnBlock
            btnStyle="danger"
            onClick={() => {
              Sentry.showReportDialog({ eventId });
            }}
          >
            Report dialog
          </Button>
          <ErrorButton />

          <Button
            className="mt-3"
            btnBlock
            btnStyle="danger"
            onClick={() => window.generateError()}
          >
            Uncaught Error
          </Button>
        </div>
      </div>
    );
  }
}

export default ErrorTesting;
